<div class="content">
    <div fxLayout="column" fxLayoutGap="2rem">
        <tnb-aktive-datenabfrage (aktiveDfChanged)="refresh()"
                                 [datenabfrage]="aktiveDatenabfrage"
                                 [aufteilungsSchluessels]="aufteilungsSchluessels$ | async"
                                 [isNvnbAssignedToAktiveDf]="isNvnbAssignedToAktiveDf"
                                 [isStadtwerk]="isStadtwerk"
                                 [isWestnetzAdmin]="isWestnetzAdmin"
                                 [isWestnetzUser]="isWestnetzUser"
        ></tnb-aktive-datenabfrage>
        @if (isWestnetzAdmin || isWestnetzUser) {
            <tnb-teilnehmer-aktive-datenabfrage (netzbetreiberAssignmentChanged)="refresh()"
                                                [assignedNetzbetreiber]="assignedNetzbetreiber"
                                                [isWestnetzAdmin]="isWestnetzAdmin"
                                                [notAssignedNetzbetreiber]="notAssignedNetzbetreiber"
            ></tnb-teilnehmer-aktive-datenabfrage>
        }
        <tnb-archivierte-datenabfrage-list
            [archivierteDatenabfragen]="archivierteDatenabfragen"
            (archivierteDfChangeds)="refresh()">
        </tnb-archivierte-datenabfrage-list>
    </div>
</div>
